const LABEL_NO = "No";
const LABEL_YES = "Yes";

const renderBoolean = <T = string>(
  value: boolean | undefined,
  trueValue: T | string = LABEL_YES,
  falseValue: T | string = LABEL_NO,
): T | string | undefined => {
  const valuesMap: Record<string, T | string> = {
    true: trueValue,
    false: falseValue,
  };

  const result = valuesMap[String(value)];

  return result;
};

export default renderBoolean;
